import auth0 from 'auth0-js';
import Config from '../Config';
import AmplitudeFlags, { REMOVE_API_SCOPES } from './amplitudeFlags';

const config = new Config();

// The API-audience scopes, as opposed to the OIDC ones the login always needs.
const API_SCOPES = ['TradeStation', 'MarketData'];

// Treatment drops the API scopes; control keeps the configured value.
const scopesWithoutApiScopes = scopes => scopes
  .split(' ')
  .filter(scope => !API_SCOPES.includes(scope))
  .join(' ');

function login(contact, credentials, scope) {
  return new Promise((resolve, reject) => {
    const params = Object.assign({
      overrides: {
        __tenant: config.auth0Tenant,
        __token_issuer: config.auth0Tenant,
      },
      domain: config.auth0Tenant,
      clientID: config.auth0ClientId,
      redirectUri: config.auth0RedirectUri,
      responseType: 'code',
    });
    const webAuth = new auth0.WebAuth(params);
    webAuth.login(
      {
        connection: config.auth0Connection,
        audience: config.auth0Audience,
        scope,
        password: credentials.password,
        username: credentials.username,
        email: contact.email,
      },
      (err) => {
        if (err) {
          reject(err);
        } else {
          resolve();
        }
      },
    );
  });
}

// The flag is the kill switch for dropping the API scopes, so a flag that will
// not resolve (Amplitude blocked by an ad blocker) counts as off and the
// configured scopes go out unchanged. Failing the other way would mean the
// switch cannot actually be switched off for those customers.
function auth0Login(contact, credentials) {
  return AmplitudeFlags.resolvePreAuthFlag(REMOVE_API_SCOPES, false)
    .then(removeScopes => login(
      contact,
      credentials,
      removeScopes ? scopesWithoutApiScopes(config.auth0Scopes) : config.auth0Scopes,
    ));
}

export default auth0Login;
